import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function PsfReducer(state = initialState.psf, action: any) {
  switch (action.type) {
    case types.SAVE_PSF_SUCCESS:
      return action.psf;
    default:
      return state;
  }
}
